export const ADD = 'NOTIFICATION/ADD'
export const REMOVE = 'NOTIFICATION/REMOVE'
export const SHOW = 'NOTIFICATION/SHOW'
export const REMOVE_AFTER_DELAY = 'NOTIFICATION/REMOVE_AFTER_DELAY'
